import { createQuoteSheet, updateQuoteSheet } from "../../../api/QuoteSheet";
import type { QuoteSheetsItems as QuoteSheetRow } from '../../../types/QuoteSheets';

export async function saveQuoteSheet(
    items: QuoteSheetRow[],
    type: 'add' | 'update',
    mode: 'edit' | 'saveAll' | string,
    data: QuoteSheetRow
): Promise<{ updatedItems: QuoteSheetRow[]; savedRow: QuoteSheetRow }> {
    let updated: QuoteSheetRow[] = [...(items ?? [])];
    let saved: QuoteSheetRow = { ...data };

    console.log('Save QuoteSheet:', type, mode, saved);
    /* ----------------------------- ADD -------------------------------- */
    if (type === 'add') {
        if (mode === 'edit' || mode === 'saveAll') {
            [saved] = await createQuoteSheet([data]);
            saved = { ...data, ...saved };
            if ((saved as any).product?.buyerDetails) {
                saved.buyerDetails = (saved as any).product.buyerDetails;
            }
            if (mode === 'edit') {
                const idx = updated.findIndex(r => r.id === saved.id);
                idx !== -1 ? (updated[idx] = saved) : updated.push(saved);
            } else {
                // saveAll (XLS batch) ➜ replace temp row that used idXLS
                const idx = updated.findIndex(
                    r => (r as any).idXLS === (data as any).idXLS
                );
                idx !== -1 ? (updated[idx] = saved) : updated.push(saved);
            }
        } else {
            if (!saved.id) saved.id = Math.floor(Math.random() * 1_000_000_000);
            updated.push(saved);
        }
    }

    /* ---------------------------- UPDATE ------------------------------ */
    else {
        if (mode === 'edit' || mode === 'saveAll') {
            const serverRow = await updateQuoteSheet(data);
            saved = { ...data, ...serverRow };
        } else {
            saved = { ...data };
        }

        updated = updated.map(r => (r.id === saved.id ? saved : r));
    }

    return { updatedItems: updated, savedRow: saved };
}